import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";

export const updateModule = (
  moduleId: number,
  data: any,
  setIsEditing: Function,
  onSuccess: Function,
  language: string
) => {
  setIsEditing(true);
  ApiService.patch(`modules/${moduleId}`, data)
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error updating module:", error);
      alert(translate(language, "PAGES.MODULE.ERROR.EDIT_MODULE_INFOS"));
    })
    .finally(() => setIsEditing(false));
};

export const fetchPrograms = (setPrograms: Function, setLoadingPrograms: Function, language: string) => {
  setLoadingPrograms(true);
  ApiService.get("programs?order_by=name&order=asc")
    .then((response) => setPrograms(response.data.programs))
    .catch((error) => {
      console.error("Error fetching programs:", error);
      alert(translate(language, "PAGES.MODULE.ERROR.LOADING_PROGRAMS"));
    })
    .finally(() => setLoadingPrograms(false));
};
